import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import xyz.malefic.laws.pages.AboutPage as _xyz_malefic_laws_pages_AboutPage
import xyz.malefic.laws.pages.HomePage as _xyz_malefic_laws_pages_HomePage
import xyz.malefic.laws.pages.Laws18_24Page as _xyz_malefic_laws_pages_Laws18_24Page
import xyz.malefic.laws.pages.Laws1_7Page as _xyz_malefic_laws_pages_Laws1_7Page
import xyz.malefic.laws.pages.Laws25_32Page as _xyz_malefic_laws_pages_Laws25_32Page
import xyz.malefic.laws.pages.Laws33_40Page as _xyz_malefic_laws_pages_Laws33_40Page
import xyz.malefic.laws.pages.Laws41_48Page as _xyz_malefic_laws_pages_Laws41_48Page
import xyz.malefic.laws.pages.Laws8_17Page as _xyz_malefic_laws_pages_Laws8_17Page

public fun main() {
    AppGlobals.initialize(mapOf("title" to "The 48 Laws of Power - Websitified!"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_HomePage()
        }
        ctx.router.register(
            "/about",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_AboutPage()
        }
        ctx.router.register(
            "/laws1-7",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_Laws1_7Page()
        }
        ctx.router.register(
            "/laws18-24",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_Laws18_24Page()
        }
        ctx.router.register(
            "/laws25-32",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_Laws25_32Page()
        }
        ctx.router.register(
            "/laws33-40",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_Laws33_40Page()
        }
        ctx.router.register(
            "/laws41-48",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_Laws41_48Page()
        }
        ctx.router.register(
            "/laws8-17",
        ) { pageCtx -> 
            _xyz_malefic_laws_pages_Laws8_17Page()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        xyz.malefic.laws.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
